import Payments from '@/modules/billing/payments/store';
import Invoices from '@/modules/billing/invoices/store';

export default { modules: [Payments, Invoices] };
